"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46020],{

/***/ 703169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Avatar; }
/* harmony export */ });
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(315017);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(716395);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(497015);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(381478);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(515555);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(640128);
/* harmony import */ var _Image_Image_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(587021);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_SIZE = {
  s: 24,
  m: 32,
  l: 40,
  xl: 48
};
const MAPPING_REWARD_COMPONENT = {
  bronze: _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .RewardBronzeCircleColored */ .y,
  silver: _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .RewardSilverCircleColored */ .r,
  gold: _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RewardGoldenCircleColored */ .d,
  platinum: _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .RewardPlatinumCircleColored */ .K
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonStyles */ .F}
  position: relative;
  border-radius: 50%;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.backgroundColor ? p.theme.colors[p.backgroundColor] : "unset"};
`;
const TextIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  display: inline-block;
  font-size: ${(p) => p.size / 2}px;
  color: ${(p) => p.theme.colors[p.color]};
  text-align: center;
`;
const ImageIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Image_Image_es_js__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E)`
  object-fit: cover;
  border-radius: 50%;
`;
const RewardIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
  background: transparent;
`;
const Avatar = (_a) => {
  var _b = _a, {
    size = "m",
    text,
    icon,
    src,
    color = "textSecondary",
    backgroundColor = "disable",
    showReward = false,
    rewardType = "gold",
    customRewardIcon
  } = _b, props = __objRest(_b, [
    "size",
    "text",
    "icon",
    "src",
    "color",
    "backgroundColor",
    "showReward",
    "rewardType",
    "customRewardIcon"
  ]);
  const actualSize = typeof size === "string" ? MAPPING_SIZE[size] : size;
  const renderChildren = () => {
    var _a2, _b2, _c, _d;
    if (!icon && !src && !text) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .AccountFilled */ .i, {
        color: "disable",
        size: actualSize
      });
    }
    if (!!src) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageIcon, {
        src,
        width: actualSize,
        height: actualSize,
        alt: "avtSrc",
        googleImageParams: { width: actualSize * 2 }
      });
    }
    if (icon) {
      return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
        size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? actualSize : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size,
        color: !((_c = icon == null ? void 0 : icon.props) == null ? void 0 : _c.color) ? color : (_d = icon == null ? void 0 : icon.props) == null ? void 0 : _d.color
      });
    }
    if (!!(text == null ? void 0 : text.length)) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TextIcon, {
        size: actualSize,
        color
      }, text[0]);
    }
  };
  const renderReward = () => {
    var _a2, _b2;
    if (!showReward && !customRewardIcon)
      return null;
    if (customRewardIcon)
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RewardIcon, null, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(customRewardIcon, {
        size: !((_a2 = customRewardIcon == null ? void 0 : customRewardIcon.props) == null ? void 0 : _a2.size) ? actualSize / 3 : (_b2 = customRewardIcon == null ? void 0 : customRewardIcon.props) == null ? void 0 : _b2.size
      }));
    const Comp = MAPPING_REWARD_COMPONENT[rewardType];
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RewardIcon, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, {
      size: actualSize / 3
    }));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    size: actualSize,
    backgroundColor: !!(text == null ? void 0 : text.length) && backgroundColor || void 0
  }), renderChildren(), renderReward());
};




/***/ }),

/***/ 134128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(425336);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const Skeleton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .b)`
  @keyframes loading {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  background-color: rgba(122, 121, 121, 0.11);
  -webkit-animation: loading 1.5s ease-in-out 0.5s infinite;
  animation: loading 1.5s ease-in-out 0.5s infinite;
  border-radius: 5px;
`;




/***/ }),

/***/ 441363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Video; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19840);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Video = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    width,
    height,
    controls,
    preload,
    autoPlay,
    playsInline,
    muted,
    src,
    className,
    tracking
  } = _a, others = __objRest(_a, [
    "width",
    "height",
    "controls",
    "preload",
    "autoPlay",
    "playsInline",
    "muted",
    "src",
    "className",
    "tracking"
  ]);
  const videoElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", __spreadValues({
    ref,
    width: width === "auto" ? width : "100%",
    height: height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)}` : "100%",
    controls,
    preload,
    autoPlay,
    playsInline,
    muted
  }, others), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", {
    src: "captions_en.vtt",
    kind: "captions",
    label: "English",
    default: true
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    src,
    type: "video/mp4"
  }), "Your browser does not support the video tag.");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadValues({
    height,
    width: width || "100%",
    className
  }, tracking), videoElement);
});
Video.displayName = "Video";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ onClick, height, width }) => `
    position: relative;
    display: inline-block;
    overflow: hidden;
    ${onClick ? "cursor: pointer;" : ""}
    ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)};` : ""}
    ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(width)};` : "width: 100%;"}
  `);




/***/ }),

/***/ 55930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ YoutubeThumbnail; },
/* harmony export */   "T": function() { return /* binding */ YoutubeFrame; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const YoutubeFrame = (_a) => {
  var _b = _a, {
    embedId,
    youtubeLink,
    title,
    autoplay = 0
  } = _b, others = __objRest(_b, [
    "embedId",
    "youtubeLink",
    "title",
    "autoplay"
  ]);
  const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("iframe", __spreadValues({
    src: `https://www.youtube.com/embed/${videoEmbedId}?autoplay=${autoplay}`,
    allowFullScreen: true,
    frameBorder: "0",
    title
  }, others));
};
const YoutubeThumbnail = (_c) => {
  var _d = _c, {
    embedId,
    youtubeLink,
    height,
    width
  } = _d, others = __objRest(_d, [
    "embedId",
    "youtubeLink",
    "height",
    "width"
  ]);
  const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
  const src = videoEmbedId ? `https://img.youtube.com/vi/${videoEmbedId}/0.jpg` : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadProps(__spreadValues({}, others), {
    src,
    height,
    width
  }));
};
const getIdFromYoutubeLink = (url) => {
  var _a;
  if (!url)
    return "";
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?)|(shorts\/))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && ((_a = match[match.length - 1]) == null ? void 0 : _a.length) === 11 ? match[match.length - 1] : "";
};




/***/ }),

/***/ 515555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ AccountFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const AccountFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 12.9483C10.2711 12.9483 8.86977 11.547 8.86977 9.8181V8.253C8.86977 6.5241 10.2711 5.1228 12 5.1228C13.7289 5.1228 15.1311 6.5241 15.1311 8.253V9.8181C15.1311 11.547 13.7289 12.9483 12 12.9483ZM10.2212 13.2947L7.70572 14.7383C6.97402 15.155 6.52222 15.9344 6.52222 16.7768V17.36C6.52222 17.36 7.88392 19.2113 12.0005 19.2113C16.1171 19.2113 17.4779 17.36 17.4779 17.36V16.7768C17.4779 15.9344 17.027 15.155 16.2953 14.7383L13.7762 13.2965C13.7762 13.2965 13.0373 13.8482 12.0005 13.8482C10.9628 13.8482 10.2212 13.2947 10.2212 13.2947Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 315017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ RewardBronzeCircleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RewardBronzeCircleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "12", fill: "white" } },
      {
        tag: "path",
        attr: {
          d: "M20.3333 6.71108C19.4129 6.71108 18.6666 7.47719 18.6666 8.42221C18.667 8.60159 18.6951 8.77978 18.75 8.9501L17.3983 9.83219C16.5083 10.4143 15.335 10.2214 14.6666 9.38302L13.3416 7.71898C13.5525 7.42755 13.6664 7.07419 13.6666 6.71112C13.6666 5.76611 12.9204 5 11.9999 5C11.0795 5 10.3332 5.76611 10.3332 6.71112C10.3334 7.07419 10.4474 7.42755 10.6582 7.71898L9.33324 9.38302C8.665 10.2209 7.49219 10.4138 6.60242 9.83219L5.25 8.9501C5.30488 8.77978 5.33301 8.60159 5.33332 8.42221C5.33348 7.47719 4.58742 6.71096 3.66691 6.7108C2.74648 6.71064 2 7.47663 2 8.42165C2 9.30875 2.66008 10.0489 3.52082 10.1265L4.50582 16.1924C4.53922 16.3986 4.71297 16.55 4.91664 16.55H19.0833C19.287 16.55 19.4607 16.3986 19.4941 16.1924L20.4791 10.1265C21.3959 10.0421 22.0725 9.21058 21.9903 8.26933C21.9133 7.38828 21.1949 6.71273 20.3333 6.71108Z",
          fill: "#F5B493"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.9998 18.261C15.9118 18.261 19.0831 17.3034 19.0831 16.1222C19.0831 14.9409 15.9118 13.9833 11.9998 13.9833C8.08781 13.9833 4.9165 14.9409 4.9165 16.1222C4.9165 17.3034 8.08781 18.261 11.9998 18.261Z",
          fill: "#E2AB8F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12 18.6889C8.2725 18.6889 4.5 17.8077 4.5 16.1222C4.5 14.4368 8.2725 13.5555 12 13.5555C15.7275 13.5555 19.5 14.4368 19.5 16.1222C19.5 17.8077 15.7275 18.6889 12 18.6889ZM12 14.4111C7.62332 14.4111 5.33332 15.5233 5.33332 16.1222C5.33332 16.7211 7.62332 17.8333 12 17.8333C16.3767 17.8333 18.6667 16.7211 18.6667 16.1222C18.6667 15.5233 16.3767 14.4111 12 14.4111Z",
          fill: "#FFD2BC"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 497015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ RewardGoldenCircleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RewardGoldenCircleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "12", fill: "white" } },
      {
        tag: "path",
        attr: {
          d: "M20.3333 6.71108C19.4129 6.71108 18.6666 7.47719 18.6666 8.42221C18.667 8.60159 18.6951 8.77978 18.75 8.9501L17.3983 9.83219C16.5083 10.4143 15.335 10.2214 14.6666 9.38302L13.3416 7.71898C13.5525 7.42755 13.6664 7.07419 13.6666 6.71112C13.6666 5.76611 12.9204 5 11.9999 5C11.0795 5 10.3332 5.76611 10.3332 6.71112C10.3334 7.07419 10.4474 7.42755 10.6582 7.71898L9.33324 9.38302C8.665 10.2209 7.49219 10.4138 6.60242 9.83219L5.25 8.9501C5.30488 8.77978 5.33301 8.60159 5.33332 8.42221C5.33348 7.47719 4.58742 6.71096 3.66691 6.7108C2.74648 6.71064 2 7.47663 2 8.42165C2 9.30875 2.66008 10.0489 3.52082 10.1265L4.50582 16.1924C4.53922 16.3986 4.71297 16.55 4.91664 16.55H19.0833C19.287 16.55 19.4607 16.3986 19.4941 16.1924L20.4791 10.1265C21.3959 10.0421 22.0725 9.21058 21.9903 8.26933C21.9133 7.38828 21.1949 6.71273 20.3333 6.71108Z",
          fill: "#FFC107"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.9998 18.2611C15.9118 18.2611 19.0831 17.3035 19.0831 16.1223C19.0831 14.941 15.9118 13.9834 11.9998 13.9834C8.08781 13.9834 4.9165 14.941 4.9165 16.1223C4.9165 17.3035 8.08781 18.2611 11.9998 18.2611Z",
          fill: "#FFA000"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12 18.689C8.2725 18.689 4.5 17.8078 4.5 16.1223C4.5 14.4369 8.2725 13.5557 12 13.5557C15.7275 13.5557 19.5 14.4369 19.5 16.1223C19.5 17.8078 15.7275 18.689 12 18.689ZM12 14.4112C7.62332 14.4112 5.33332 15.5234 5.33332 16.1223C5.33332 16.7212 7.62332 17.8335 12 17.8335C16.3767 17.8335 18.6667 16.7212 18.6667 16.1223C18.6667 15.5234 16.3767 14.4112 12 14.4112Z",
          fill: "#FFD54F"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 381478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ RewardPlatinumCircleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RewardPlatinumCircleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "12", fill: "white" } },
      {
        tag: "path",
        attr: {
          d: "M20.3333 6.71108C19.4129 6.71108 18.6666 7.47719 18.6666 8.42221C18.667 8.60159 18.6951 8.77978 18.75 8.9501L17.3983 9.83219C16.5083 10.4143 15.335 10.2214 14.6666 9.38302L13.3416 7.71898C13.5525 7.42755 13.6664 7.07419 13.6666 6.71112C13.6666 5.76611 12.9204 5 11.9999 5C11.0795 5 10.3332 5.76611 10.3332 6.71112C10.3334 7.07419 10.4474 7.42755 10.6582 7.71898L9.33324 9.38302C8.665 10.2209 7.49219 10.4138 6.60242 9.83219L5.25 8.9501C5.30488 8.77978 5.33301 8.60159 5.33332 8.42221C5.33348 7.47719 4.58742 6.71096 3.66691 6.7108C2.74648 6.71064 2 7.47663 2 8.42165C2 9.30875 2.66008 10.0489 3.52082 10.1265L4.50582 16.1924C4.53922 16.3986 4.71297 16.55 4.91664 16.55H19.0833C19.287 16.55 19.4607 16.3986 19.4941 16.1924L20.4791 10.1265C21.3959 10.0421 22.0725 9.21058 21.9903 8.26933C21.9133 7.38828 21.1949 6.71273 20.3333 6.71108Z",
          fill: "#9980FF"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.9998 18.261C15.9118 18.261 19.0831 17.3034 19.0831 16.1222C19.0831 14.9409 15.9118 13.9833 11.9998 13.9833C8.08781 13.9833 4.9165 14.9409 4.9165 16.1222C4.9165 17.3034 8.08781 18.261 11.9998 18.261Z",
          fill: "#846CE2"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12 18.6889C8.2725 18.6889 4.5 17.8077 4.5 16.1222C4.5 14.4368 8.2725 13.5555 12 13.5555C15.7275 13.5555 19.5 14.4368 19.5 16.1222C19.5 17.8077 15.7275 18.6889 12 18.6889ZM12 14.4111C7.62332 14.4111 5.33332 15.5233 5.33332 16.1222C5.33332 16.7211 7.62332 17.8333 12 17.8333C16.3767 17.8333 18.6667 16.7211 18.6667 16.1222C18.6667 15.5233 16.3767 14.4111 12 14.4111Z",
          fill: "#BEADFF"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 716395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ RewardSilverCircleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RewardSilverCircleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "12", fill: "white" } },
      {
        tag: "path",
        attr: {
          d: "M20.3333 6.71108C19.4129 6.71108 18.6666 7.47719 18.6666 8.42221C18.667 8.60159 18.6951 8.77978 18.75 8.9501L17.3983 9.83219C16.5083 10.4143 15.335 10.2214 14.6666 9.38302L13.3416 7.71898C13.5525 7.42755 13.6664 7.07419 13.6666 6.71112C13.6666 5.76611 12.9204 5 11.9999 5C11.0795 5 10.3332 5.76611 10.3332 6.71112C10.3334 7.07419 10.4474 7.42755 10.6582 7.71898L9.33324 9.38302C8.665 10.2209 7.49219 10.4138 6.60242 9.83219L5.25 8.9501C5.30488 8.77978 5.33301 8.60159 5.33332 8.42221C5.33348 7.47719 4.58742 6.71096 3.66691 6.7108C2.74648 6.71064 2 7.47663 2 8.42165C2 9.30875 2.66008 10.0489 3.52082 10.1265L4.50582 16.1924C4.53922 16.3986 4.71297 16.55 4.91664 16.55H19.0833C19.287 16.55 19.4607 16.3986 19.4941 16.1924L20.4791 10.1265C21.3959 10.0421 22.0725 9.21058 21.9903 8.26933C21.9133 7.38828 21.1949 6.71273 20.3333 6.71108Z",
          fill: "#E5E0D1"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.9998 18.261C15.9118 18.261 19.0831 17.3034 19.0831 16.1222C19.0831 14.9409 15.9118 13.9833 11.9998 13.9833C8.08781 13.9833 4.9165 14.9409 4.9165 16.1222C4.9165 17.3034 8.08781 18.261 11.9998 18.261Z",
          fill: "#DDD3C0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12 18.6889C8.2725 18.6889 4.5 17.8077 4.5 16.1222C4.5 14.4368 8.2725 13.5555 12 13.5555C15.7275 13.5555 19.5 14.4368 19.5 16.1222C19.5 17.8077 15.7275 18.6889 12 18.6889ZM12 14.4111C7.62332 14.4111 5.33332 15.5233 5.33332 16.1222C5.33332 16.7211 7.62332 17.8333 12 17.8333C16.3767 17.8333 18.6667 16.7211 18.6667 16.1222C18.6667 15.5233 16.3767 14.4111 12 14.4111Z",
          fill: "#F0E9D7"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 627530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ TickFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const TickFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: {
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 477.867 477.867",
      style: "enable-background:new 0 0 477.867 477.867;"
    },
    child: [
      {
        tag: "g",
        attr: {},
        child: [
          {
            tag: "g",
            attr: {},
            child: [
              {
                tag: "path",
                attr: {
                  d: "M238.933,0C106.974,0,0,106.974,0,238.933s106.974,238.933,238.933,238.933s238.933-106.974,238.933-238.933\n			C477.726,107.033,370.834,0.141,238.933,0z M370.466,165.666L199.799,336.333c-6.665,6.663-17.468,6.663-24.132,0l-68.267-68.267\n			c-6.78-6.548-6.968-17.352-0.42-24.132c6.548-6.78,17.352-6.968,24.132-0.42c0.142,0.138,0.282,0.277,0.42,0.42l56.201,56.201\n			l158.601-158.601c6.78-6.548,17.584-6.36,24.132,0.419C376.854,148.567,376.854,159.052,370.466,165.666z"
                }
              }
            ]
          }
        ]
      },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] },
      { tag: "g", attr: {}, child: [] }
    ]
  })(props);
};




/***/ }),

/***/ 14766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FacebookComment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(724656);




const FacebookComment = ({
  href,
  numPosts,
  width,
  appId,
  language,
  colorScheme,
  mobile,
  lazy
}) => {
  const { available, fb, xfbmlParse } = (0,_useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useFacebookSDK */ .c)(appId, language);
  const [xfbmlRender, setRender] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!fb || !available)
      return;
    setRender(false);
    if (ref.current) {
      ref.current.style.height = "1px";
    }
    xfbmlParse();
    fb.Event.subscribe("xfbml.render", () => {
      setRender(true);
      if (ref.current) {
        ref.current.style.height = "auto";
      }
    });
    return () => {
      fb.Event.unsubscribe("xfbml.render", () => {
        setRender(false);
      });
    };
  }, [fb, href, numPosts, available]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, available ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !xfbmlRender && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FacebookCommentSkeleton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fb-comments",
    "data-href": href,
    "data-numposts": numPosts,
    "data-width": width,
    "data-lazy": lazy,
    "data-mobile": mobile,
    "data-colorscheme": colorScheme
  }))) : null);
};
FacebookComment.displayName = "FacebookComment";
FacebookComment.defaultProps = {
  width: "100%",
  numPosts: 5,
  colorScheme: "light",
  mobile: "auto-detect",
  lazy: true
};
const FacebookCommentSkeleton = () => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "0.5rem",
    marginBottom: "s36",
    padding: ["s8", "s0"]
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: 1,
    marginBottom: "s24"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "4rem",
    width: "100%",
    marginBottom: "s16"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  overflow: hidden;
`;




/***/ }),

/***/ 724656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useFacebookSDK; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [available, setAvailable] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _a;
    if (typeof window === "undefined")
      return;
    if (typeof FB != "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=v16.0&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};




/***/ }),

/***/ 888393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Gallery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(676662);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55930);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(670894);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875547);
/* harmony import */ var _ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7297);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const GalaryFooter = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(({ indexActive, setIndexActive, onSlideChange, images, videos = [] }, ref) => {
  const wrapper = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const vidRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const changeSlide = (index) => {
    setIndexActive(index);
    if (typeof ref !== "function" && (ref == null ? void 0 : ref.current) && wrapper.current) {
      const itemPercents = (index + 0.5) / images.length;
      const itemsRect = ref.current.getBoundingClientRect();
      const wrapperRect = wrapper.current.getBoundingClientRect();
      const widthTransform = itemPercents * wrapperRect.width - itemsRect.width / 2;
      wrapper.current.style.transform = `translateX(-${widthTransform}px)`;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof ref !== "function" && (ref == null ? void 0 : ref.current)) {
      ref.current.go = changeSlide;
    }
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Items, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemsWrapper, {
    ref: wrapper
  }, [...videos, ...images].map((media, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterItem, {
    key: index,
    className: index === indexActive ? "active" : ""
  }, index < videos.length ? media.source === _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .SOURCE_VIDEO.SYSTEM */ .Ok.SYSTEM ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ThumbnailVideo, {
    url: media.src,
    source: media.source,
    videoProps: {
      ref: vidRef,
      width: 60,
      height: 60,
      preload: "none",
      playsInline: true,
      autoPlay: true,
      muted: true,
      onClick: () => onSlideChange(index),
      onPlayingCapture: () => {
        var _a;
        return (_a = vidRef.current) == null ? void 0 : _a.pause();
      }
    }
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .YoutubeThumbnail */ .F, {
    key: index,
    width: 60,
    height: 60,
    youtubeLink: media.src,
    onClick: () => onSlideChange(index)
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Thumbnail, __spreadProps(__spreadValues({}, media), {
    contain: true,
    width: 60,
    height: 60,
    imageWidth: 150,
    borderRadius: 4,
    onClick: () => onSlideChange(index)
  })))))));
});
GalaryFooter.displayName = "GalaryFooter";
const ItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  gap: 0.75rem;
  transition: all 0.3s ease-in;
`;
const GalleryIndex = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: absolute;
  right: 10px;
  top: 20px;

  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Gallery = ({
  images,
  videos = [],
  onClose,
  bgColor,
  indexVisible,
  footerVisible = true,
  frame,
  activeImageIndex
}) => {
  const [indexActive, setIndexActive] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(activeImageIndex || 0);
  const footerController = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const carouselController = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onSlideChange = (type, index) => {
    var _a, _b, _c;
    if (type == "carousel") {
      (_a = footerController.current) == null ? void 0 : _a.go(index);
    } else {
      (_c = (_b = carouselController.current) == null ? void 0 : _b.glide) == null ? void 0 : _c.go(`=${index}`);
    }
  };
  const listOfMedia = [...videos, ...images];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    backgroundColor: bgColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    style: { position: "absolute", width: "100%", zIndex: 10 },
    justify: indexVisible ? "space-between" : "end",
    padding: ["s12", "s16"]
  }, onClose && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonClose, {
    onClick: onClose
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CloseOutlined */ .X, {
    size: 30,
    color: "textSecondary"
  })), indexVisible && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalleryIndex, null, indexActive + 1, " / ", listOfMedia.length)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A, {
    type: "slider",
    perView: 1,
    autoplay: false,
    ref: carouselController,
    onSlideChange: (index) => onSlideChange("carousel", index),
    startAt: indexActive
  }, listOfMedia.map((media, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GlideItem, {
      key: index,
      height: "100%",
      frame
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, index < videos.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ProductVideo */ .N, {
      url: media.src,
      source: media.source,
      videoProps: {
        width: "100%",
        height: "100%",
        controls: true,
        preload: "none",
        autoPlay: true,
        playsInline: true,
        muted: true
      },
      youtubeFrameProps: {
        width: "100%",
        height: 400,
        autoplay: 1
      }
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, __spreadProps(__spreadValues({
      contain: true
    }, media), {
      imageWidth: 1e3
    }))));
  }))), footerVisible && !!listOfMedia.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalaryFooter, {
    indexActive,
    setIndexActive,
    images,
    ref: footerController,
    onSlideChange: (index) => onSlideChange("footer", index),
    videos
  }));
};
const GlideItem = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k)`
  background-image: ${({ frame }) => `url(${frame})`};
  background-size: cover;
`;
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  .glide__slide {
    height: 100%;
  }
`;
const Footer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  margin: 1rem auto;
  padding: 0 1.5rem;
  width: 800px;
  max-width: 100%;
  z-index: 3;
  text-align: left;

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const FooterItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  opacity: 0.4;

  &.active {
    opacity: 1;
  }
  img {
    user-select: none;
    -webkit-user-drag: none;
  }
`;
const Items = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Thumbnail = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w)`
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ThumbnailVideo = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ProductVideo */ .N)`
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  background: transparent;
  width: 700px;
  max-height: 100%;
  max-width: 100%;
  position: relative;
  margin: auto;
`;
const StyledContainer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  height: 100%;
  z-index: 4;
  width: 100%;
  > div {
    height: 100%;
    width: 100%;
  }
`;
const ButtonClose = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ theme }) => `
  cursor: pointer;
  padding: 4px;
  &:hover {
    path{
      fill: ${theme == null ? void 0 : theme.colors.primary500} !important;
    }
  }
`);




/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ProductVideo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875547);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(441363);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55930);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductVideo = (props) => {
  const { url, source, videoProps, youtubeFrameProps } = props;
  if (source === _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .SOURCE_VIDEO.SYSTEM */ .Ok.SYSTEM) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Video */ .n, __spreadProps(__spreadValues({}, videoProps), {
      src: url
    }));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .YoutubeFrame */ .T, __spreadValues({
    youtubeLink: url
  }, youtubeFrameProps));
};




/***/ }),

/***/ 325710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SellerCard; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(703169);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(627530);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SellerCard = (_a) => {
  var _b = _a, {
    avatar,
    name,
    link,
    slogan,
    showSlogan = true,
    showTick = true,
    isAvatarHidden = false
  } = _b, rest = __objRest(_b, [
    "avatar",
    "name",
    "link",
    "slogan",
    "showSlogan",
    "showTick",
    "isAvatarHidden"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), !isAvatarHidden && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledAvatar, __spreadValues({
    size: "l",
    borderColor: "divider",
    borderStyle: "solid"
  }, avatar)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 2,
    hoverColor: "primary500"
  }, name, showTick && !isAvatarHidden && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .TickFilled */ .i, {
    color: "success500",
    size: 14,
    style: { marginLeft: "8px", marginBottom: "4px" }
  }))), showSlogan && slogan && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary"
  }, slogan)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border-radius: 0.5rem;
`;
const StyledAvatar = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Avatar */ .q)`
  img {
    object-fit: contain;
  }
`;




/***/ }),

/***/ 732324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ SmallImage; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(788925);




const SmallImage = ({
  image,
  isActive,
  extra,
  onClick,
  onMouseEnter,
  width = 50,
  height = 50,
  borderRadius = 4,
  borderColor = "transparent",
  borderWidth = 1
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    isActive: !!isActive,
    onClick,
    onMouseEnter,
    width,
    height,
    borderRadius,
    borderColor,
    borderWidth
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_1__/* .EnhancedImage */ .N, {
    src: image.src,
    alt: image.alt,
    objectFit: "contain",
    borderRadius,
    width,
    height
  }), extra && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Extra, null, extra));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isActive,
  theme,
  width,
  height,
  borderRadius,
  borderColor,
  borderWidth
}) => `
  border-radius: ${typeof borderRadius === "string" ? borderRadius : `${borderRadius}px`};
  border: ${typeof borderWidth === "string" ? borderWidth : `${borderWidth}px`} solid ${isActive ? theme == null ? void 0 : theme.colors.primary500 : borderColor};
  position: relative;
  cursor: pointer;
  width: ${typeof width === "string" ? width : `${width}px`};
  height: ${typeof height === "string" ? height : `${height}px`};
  overflow: hidden;
`);
const Extra = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;




/***/ })

}]);